import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

export type Response<RequestType, ResponseType> = {
  get: (route: string, config?: AxiosRequestConfig) => Promise<AxiosResponse<ResponseType>>;
  post: (
    route: string,
    data?: RequestType,
    config?: AxiosRequestConfig
  ) => Promise<AxiosResponse<ResponseType>>;
  put: (
    route: string,
    data: RequestType,
    config?: AxiosRequestConfig
  ) => Promise<AxiosResponse<ResponseType>>;
  patch: (
    route: string,
    data: RequestType,
    config?: AxiosRequestConfig
  ) => Promise<AxiosResponse<ResponseType>>;
  delete: (route: string, config?: AxiosRequestConfig) => Promise<AxiosResponse<ResponseType>>;
}

const instance = axios.create();

const request = <RequestType, ResponseType>(
  defaultConfig?: AxiosRequestConfig
): Response<RequestType, ResponseType> => {
  instance.defaults = { ...instance.defaults, ...defaultConfig, headers: {...instance.defaults.headers, ...defaultConfig?.headers } };

  const get = (route: string, config?: AxiosRequestConfig): Promise<AxiosResponse<ResponseType>> =>
    instance.get(route, { ...defaultConfig, ...config });

  const post = (
    route: string,
    data?: RequestType,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<ResponseType>> =>
    instance.post(route, data, { ...defaultConfig, ...config });

  const put = (
    route: string,
    data: RequestType,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<ResponseType>> =>
    instance.put(route, data, { ...defaultConfig, ...config });

  const patch = (
    route: string,
    data: RequestType,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<ResponseType>> =>
    instance.patch(route, data, { ...defaultConfig, ...config });

  const axiosDelete = (
    route: string,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<ResponseType>> =>
    instance.delete(route, { ...defaultConfig, ...config });

  return {
    get,
    post,
    put,
    patch,
    delete: axiosDelete
  };
};

export const axiosInterceptors = instance.interceptors;

export default request;
